'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

const React = require('react');
const React__default = _interopDefault(React);
const modalWithAnimation = require('../ModalWithAnimation/modalWithAnimation.js');

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["backdropProps", "closeButtonProps", "contentProps", "dataAttr", "isCentered"],
  _excluded2 = ["dataAttr"],
  _excluded3 = ["dataAttr"],
  _excluded4 = ["dataAttr"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
var COMPONENT_KEY = 'lightbox';
var DEFAULT_DATA_ATTR = {
  'data-testid': COMPONENT_KEY
};
var DEFAULT_DATA_ATTR_BACKDROP = {
  'data-testid': "".concat(COMPONENT_KEY, "__backdrop")
};
var DEFAULT_DATA_ATTR_CLOSE_BUTTON = {
  'data-testid': "".concat(COMPONENT_KEY, "__close-button")
};
var DEFAULT_DATA_ATTR_CONTENT = {
  'data-testid': "".concat(COMPONENT_KEY, "__content-container")
};
var Lightbox = function Lightbox(_ref) {
  var _ref$backdropProps = _ref.backdropProps,
    backdropProps = _ref$backdropProps === void 0 ? {} : _ref$backdropProps,
    _ref$closeButtonProps = _ref.closeButtonProps,
    closeButtonProps = _ref$closeButtonProps === void 0 ? {} : _ref$closeButtonProps,
    _ref$contentProps = _ref.contentProps,
    contentProps = _ref$contentProps === void 0 ? {} : _ref$contentProps,
    dataAttr = _ref.dataAttr,
    _ref$isCentered = _ref.isCentered,
    isCentered = _ref$isCentered === void 0 ? true : _ref$isCentered,
    props = _objectWithoutProperties(_ref, _excluded);
  var backdropDataAttr = backdropProps.dataAttr,
    restBackdropProps = _objectWithoutProperties(backdropProps, _excluded2);
  var combinedBackdropProps = _objectSpread({
    dataAttr: _objectSpread(_objectSpread({}, DEFAULT_DATA_ATTR_BACKDROP), backdropDataAttr)
  }, restBackdropProps);
  var closeButtonDataAttr = closeButtonProps.dataAttr,
    restCloseButtonProps = _objectWithoutProperties(closeButtonProps, _excluded3);
  var combinedCloseButtonProps = _objectSpread({
    dataAttr: _objectSpread(_objectSpread({}, DEFAULT_DATA_ATTR_CLOSE_BUTTON), closeButtonDataAttr)
  }, restCloseButtonProps);
  var contentDataAttr = contentProps.dataAttr,
    restContentProps = _objectWithoutProperties(contentProps, _excluded4);
  var combinedContentProps = _objectSpread({
    dataAttr: _objectSpread(_objectSpread({}, DEFAULT_DATA_ATTR_CONTENT), contentDataAttr)
  }, restContentProps);
  var combinedDataAttr = _objectSpread(_objectSpread({}, DEFAULT_DATA_ATTR), dataAttr);
  return /*#__PURE__*/React__default.createElement(modalWithAnimation.default, _extends({
    backdropProps: combinedBackdropProps,
    closeButtonProps: combinedCloseButtonProps,
    contentProps: combinedContentProps,
    dataAttr: combinedDataAttr,
    isCentered: isCentered
  }, props));
};
const lightbox = /*#__PURE__*/React__default.memo(Lightbox);

module.exports = lightbox;
